import { render, staticRenderFns } from "./cbrAccProducts.vue?vue&type=template&id=abb4c448&lang=pug"
import script from "./cbrAccProducts.vue?vue&type=script&lang=js"
export * from "./cbrAccProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports